module.exports = __webpack_public_path__ + "static/img/meet-our-executive-team_1.de78821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/meet-our-executive-team_1.png
// module id = AIJz
// module chunks = 0